module.exports = __webpack_public_path__ + "static/shotlists_takes@3x-75c2c7feb19321315415eda39292c61c.png";